"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reselect = require("reselect");

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function isShallowEqual(a, b) {
  if (_typeof(a) !== 'object' || _typeof(b) !== 'object') {
    return a === b;
  }

  var aIsArray = Array.isArray(a);
  var bIsArray = Array.isArray(b);

  if (aIsArray !== bIsArray) {
    return false;
  }

  if (aIsArray) {
    return a.length === b.length && a.every(function (val, index) {
      return val === b[index];
    });
  }

  var keysA = Object.keys(a);
  var keysB = Object.keys(b);

  if (keysA.length !== keysB.length) {
    return false;
  }

  return keysA.every(function (key) {
    return a[key] === b[key];
  });
}

var createShallowEqualSelector = (0, _reselect.createSelectorCreator)(_reselect.defaultMemoize, isShallowEqual);
var _default = createShallowEqualSelector;
exports.default = _default;